import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

// workaround to find the translate function sometimes in
// translator, sometimes not...
// To be removed one day (please use Flow).
// $FlowFixMe[missing-local-annot]
const getTranslatorFunc = props => get(props, 'translator.__') || get(props, '__') || (str => {
  // eslint-disable-next-line no-console
  console.error('Translate function has not been found!');
  return str;
});

// $FlowFixMe[missing-local-annot]
const isEmpty = value => value === undefined || value === null || value === '' || Array.isArray(value) && value.length === 0;

// $FlowFixMe[missing-local-annot]
const join = rules => (value, data, props) => rules.map(rule => rule(value, data, props)).filter(error => !!error)[0];
export function required(
// $FlowFixMe[unclear-type]
value, data, props
// $FlowFixMe[unclear-type]
) {
  if (isEmpty(value)) {
    return getTranslatorFunc(props)('Required');
  }
  return undefined;
}
export function url(
// $FlowFixMe[unclear-type]
value, data, props
// $FlowFixMe[unclear-type]
) {
  if (!isEmpty(value) &&
  // eslint-disable-next-line no-useless-escape
  !/^([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i.test(value)) {
    return getTranslatorFunc(props)('Invalid URL');
  }
  return undefined;
}
export function maxLength(max
// $FlowFixMe[unclear-type]
) {
  return (value, data, props) => {
    if (!isEmpty(value) && value.length > max) {
      return getTranslatorFunc(props)('Must be no more than %(max)s characters', {
        max
      });
    }
    return undefined;
  };
}

// $FlowFixMe[recursive-definition]
// $FlowFixMe[missing-local-annot]
function computeErrors(rules, data, props) {
  const errors = {};
  Object.keys(rules).forEach(key => {
    if (isPlainObject(rules[key])) {
      // $FlowFixMe[prop-missing]
      errors[key] = computeErrors(rules[key], data[key], props);
    } else {
      // concat enables both functions and arrays of functions
      const rule = join([].concat(rules[key]));
      const error = rule(data ? data[key] : undefined, data, props);
      if (error) {
        // $FlowFixMe[prop-missing]
        errors[key] = error;
      }
    }
  });
  return errors;
}

// $FlowFixMe[unclear-type]
export function createValidator(rules) {
  // eslint-disable-next-line default-param-last
  return (data = {}, props) => computeErrors(rules, data, props);
}

/**
 * Clean the error object.
 *
 * Some APIs or validators returns empty errors, this is a simple utility that
 * aims at removing empty errors.
 *
 * @param object errors the err
 * @return object
 */
// $FlowFixMe[unclear-type]
export function clean(errors) {
  if (!errors) return {};
  return Object.keys(errors).reduce((acc, key) => {
    if (isEmpty(errors[key])) {
      return acc;
    }
    return {
      ...acc,
      [key]: errors[key]
    };
  }, {});
}